export const mapFaq = {
  benefits:
    'https://faq.flashapp.com.br/kb/guide/pt-BR/fale-com-a-gente-horarios-e-canais-de-atendimento-do-time-beneficios-wZy60uDVXg/Steps/4198068',
  corporateCard:
    'https://faq.flashapp.com.br/kb/guide/pt-BR/fale-com-a-gente-horarios-e-canais-de-atendimento-do-time-despesas-a1W0G7E5Lu/Steps/4198062',
  expense:
    'https://faq.flashapp.com.br/kb/guide/pt-BR/fale-com-a-gente-horarios-e-canais-de-atendimento-do-time-despesas-a1W0G7E5Lu/Steps/4198062',
  people:
    'https://faq.flashapp.com.br/kb/guide/pt-BR/fale-com-a-gente-horarios-e-canais-de-atendimento-do-time-de-gestao-de-pessoas-NtYNN6pFXL/Steps/4198069',
}
